/**
 * Displays a toaster notification based on the type of message
 * @returns {{success: (function(*=): *), clear(*=): undefined, warning: (function(*=, *=): *), error: (function(*=, *=): *), info: (function(*=): *)}}
 */
const notify = function () {
    // Set default options for the toastr message
    toastr.options.closeButton = true;
    toastr.options.positionClass = "toast-top-right";
    toastr.options.preventDuplicates = true;

    let lastNotification;

    return {
        success: function (text) {
            return lastNotification = toastr.success(text, "Success");
        },
        info: function (text) {
            return lastNotification = toastr.info(text, "Info");
        },
        error: function (text, timeoutMs, noCloseButton) {
            const options = {
                positionClass: "toast-bottom-full-width",
                closeButton: !noCloseButton
            };
            if (timeoutMs !== undefined) {
                options.timeOut = timeoutMs;
            }

            return lastNotification = toastr.error(text, "Error", options);
        },
        warning: function (text, title) {
            return lastNotification = toastr.warning(text, title || "Warning");
        },
        clear() {
            const args = Array.from(arguments);
            if (args.length === 0 && lastNotification) {
                args.push(lastNotification);
            }
            if (!args.length) {
                return;
            }
            args.forEach(el => toastr.clear(el));
        }
    };
};

angular.module("dashboard").factory("notify", notify);
